(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/input-range-group/assets/javascripts/input-range-group.js') >= 0) return;  svs.modules.push('/components/lb-ui/input-range-group/assets/javascripts/input-range-group.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useState,
  useEffect
} = React;
const {
  Input
} = svs.ui.form;
const {
  DebounceOnEvent
} = svs.components.lbUi;
const {
  clx
} = svs.components.lbUtils;
const {
  InputRange
} = svs.components.lbUi.inputRange;
const ENTER_KEY = 'Enter';
const MS_TO_AVOID_SAFARI_HISTORY_LIMIT_100_TIMES_IN_30_SECONDS = 350;
const InputRangeGroup = props => {
  const {
    className,
    isInfiniteMax,
    maxCap,
    maxLabel,
    minCap,
    minLabel,
    onChange,
    selectedMin: propsMin,
    selectedMax: propsMax,
    suffix
  } = props;
  const [currRange, setCurrRange] = useState({
    min: propsMin,
    max: propsMax
  });
  useEffect(() => {
    if (propsMin === minCap && propsMax === maxCap) {
      setCurrRange({
        min: propsMin,
        max: propsMax
      });
    }
  }, [maxCap, minCap, props, propsMax, propsMin]);
  const handleMinChange = _ref => {
    let {
      target
    } = _ref;
    if (target.value) {
      setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
        min: parseInt(target.value, 10)
      }));
    }
  };
  const handleMinBlur = _ref2 => {
    let {
      target
    } = _ref2;
    const newMin = Math.min(Math.max(parseInt(target.value || 0, 10), minCap), currRange.max);
    setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
      min: newMin
    }));
    onChange({
      selectedMin: newMin,
      selectedMax: currRange.max
    });
  };
  const handleMaxChange = _ref3 => {
    let {
      target
    } = _ref3;
    if (target.value) {
      setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
        max: parseInt(target.value, 10)
      }));
    }
  };
  const handleMaxBlur = _ref4 => {
    let {
      target
    } = _ref4;
    const newMax = Math.min(Math.max(parseInt(target.value || 0, 10), currRange.min), maxCap);
    setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
      max: newMax
    }));
    onChange({
      selectedMin: currRange.min,
      selectedMax: newMax
    });
  };
  const handleRangeChangeDirectly = _ref5 => {
    let {
      selectedMin,
      selectedMax
    } = _ref5;
    setCurrRange({
      min: selectedMin,
      max: isInfiniteMax && selectedMax === isInfiniteMax ? Infinity : selectedMax
    });
  };
  const handleRangeChangeDelayed = _ref6 => {
    let {
      selectedMin,
      selectedMax
    } = _ref6;
    onChange({
      selectedMin,
      selectedMax: isInfiniteMax && selectedMax === isInfiniteMax ? Infinity : selectedMax
    });
  };
  const handleKeyDown = _ref7 => {
    let {
      key,
      target
    } = _ref7;
    if (key === ENTER_KEY) {
      target.blur();
    }
  };
  const handleClick = _ref8 => {
    let {
      target
    } = _ref8;
    target.focus();
    target.select();
  };
  return React.createElement("div", {
    className: clx('input-range-group', className),
    "data-testid": "qa-input-range-group"
  }, React.createElement("div", {
    className: "input-range-values"
  }, React.createElement(Input, {
    "aria-label": minLabel,
    className: "std-input-100 qa-input-range-group-min",
    max: maxCap,
    min: minCap,
    onBlur: handleMinBlur,
    onChange: handleMinChange,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    pattern: "[0-9]+",
    placeholder: "",
    suffix: suffix,
    type: "tel",
    value: currRange.min
  }), React.createElement(Input, {
    "aria-label": maxLabel,
    className: "std-input-100 qa-input-range-group-max",
    max: maxCap,
    min: minCap,
    onBlur: handleMaxBlur,
    onChange: handleMaxChange,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    pattern: "[0-9]+",
    placeholder: "",
    suffix: suffix,
    type: "tel",
    value: isInfiniteMax && currRange.max === maxCap ? "".concat(maxCap, "+") : currRange.max
  })), React.createElement("div", {
    className: "input-range-field"
  }, React.createElement(DebounceOnEvent, {
    delayMS: MS_TO_AVOID_SAFARI_HISTORY_LIMIT_100_TIMES_IN_30_SECONDS,
    onEventDelayed: handleRangeChangeDelayed,
    onEventDirectly: handleRangeChangeDirectly
  }, _ref9 => {
    let {
      handleEvent
    } = _ref9;
    return React.createElement(InputRange, {
      maxCap: maxCap,
      minCap: minCap,
      onChange: handleEvent,
      selectedMax: currRange.max,
      selectedMin: currRange.min
    });
  })));
};
InputRangeGroup.defaultProps = {
  isInfiniteMax: false,
  maxLabel: 'Högsta andelspris',
  minLabel: 'Minsta andelspris'
};
setGlobal('svs.components.lbUi.inputRangeGroup.InputRangeGroup', InputRangeGroup);

 })(window);